import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { Resource, ResourceCategory } from './resource-service.types';
import { PagedResponse } from '@bioconnect-ui/shared-service';

export interface ResourceConfig {
  restServer: string;
}

@Injectable({
  providedIn: 'root'
})
export class ResourceService {

  constructor(private httpClient: HttpClient,
    @Inject('resourceConfig') private env: ResourceConfig) { }

  private restServer = this.env.restServer;


  /**
   * Get a list of all resources, with a large page size to fetch in one request
   */
  getAllResources(): Observable<Resource[]> {
    return this.httpClient.get<PagedResponse>(
      `${this.restServer}/metadata_repository/resource/?page_size=1000`
    ).pipe(map((result) => <Resource[]>result.results));
  }

  getResources(
    filter: string,
    pageNumber: number,
    sort: string,
    direction: string,
    pageSize: number
  ): Observable<PagedResponse> {
    let url = `${this.restServer}/metadata_repository/resource/`;
    url += `?filter=${filter}&page=${pageNumber}&page_size=${pageSize}&sort=${sort}&direction=${direction}`;
    return this.httpClient.get<PagedResponse>(url);
  }

  getResource(id: number): Observable<Resource> {
    return this.httpClient.get<Resource>(
      `${this.restServer}/metadata_repository/resource/${id}/`
    );
  }

  addResource(resource: Resource): Observable<Resource> {
    return this.httpClient.post<Resource>(
      `${this.restServer}/metadata_repository/resource/`,
      resource
    );
  }

  updateResource(resource: Resource): Observable<Resource> {
    return this.httpClient.patch<Resource>(
      `${this.restServer}/metadata_repository/resource/${resource.id}/`,
      resource
    );
  }

  getResourceCategories(): Observable<ResourceCategory[]> {
    return this.httpClient.get<PagedResponse>(
      `${this.restServer}/metadata_repository/resource_category/?page_size=1000`
    ).pipe(map((result) => <ResourceCategory[]>result.results));
  }

  deleteResource(id: number) {
    return this.httpClient.delete(
      `${this.restServer}/metadata_repository/resource/${id}/`
    )
  }
}
